import src from "IMAGE";
export default { src, width: 14, height: 11, blurWidth: 0, blurHeight: 0};
